export default "__VITE_ASSET__mDdB_shI__"